module.exports = __webpack_public_path__ + "ef239632a9cbb76baabb839a37c5f5ae.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/widget-icons/pencil.png
// module id = 3701
// module chunks = 0